export default {
  // التنقل
  nav: {
    home: 'الرئيسية',
    about: 'من نحن',
    services: 'الخدمات الذكية',
    products: 'المنتجات الذكية',
    computing: 'مركز الحوسبة',
    news: 'أخبار لينك',
    contact: 'اتصل بنا',
  },
  hero: {
    title1: 'قيادة',
    title2: '',
    subTitle: 'بناء ذكاء البيانات للذكاء الاصطناعي من الجيل القادم، واستخدام قوة الحوسبة لتحرير الموارد البشرية',
  },
  about: {
    title: 'عن لينك زهوا',
    subTitle: 'مزود خدمة ذكاء البيانات للمؤسسات',
    description:
      'لينك زهوا هو مزود خدمة يركز على حلول ذكاء البيانات للمؤسسات. بمهمة "استخدام قوة الحوسبة لتحرير الموارد البشرية"، نقدم معالجة البيانات الكاملة، وحلول الذكاء الاصطناعي والتنفيذ، وخدمات بناء مركز الحوسبة الفائقة لصناعات متعددة.',

    description1:
      'تستفيد الشركة من تراكمها العميق في تقنيات معالجة البيانات والذكاء الاصطناعي لمساعدة المؤسسات على تحقيق التحول الرقمي والذكي.',
    description2:
      'وانغ شوهوي، مؤسس ورئيس لينك زهوا، تخرج من جامعة ستانفورد وهو عالم في مجالات الذكاء الاصطناعي والبيانات الضخمة والبلوك تشين. وهو عالم أساسي مبكر في Scale AI وبناء مشاريع علوم الرسم في الولايات المتحدة، وعضو في جمعية العلماء الصينيين، وجمعية آلات الحوسبة (ACM)، والجمعية الدولية للذكاء الاصطناعي (AAAI).',
    description3:
      'وانغ سوجون، مؤسس الشركة ورئيسها، شغل سابقاً منصب المدير الوطني للمبيعات في شركة يوني-برزيدنت إنتربرايزز، حيث أدار فريقاً خارج الخط يضم 10,000 شخص وتولى إدارة إيرادات سنوية تصل إلى مليارات اليوان.',
    description4:
      'وفي الوقت نفسه، كشركة رئيسية في منطقة لينغانغ الجديدة في شنغهاي، حصلت لينك زهوا أيضاً على اهتمام ودعم واسع من القادة وجميع قطاعات المجتمع.',
  },
  partners: {
    title: 'شركاء موثوقون',
    subTitle: 'العمل مع المؤسسات الرائدة في الصناعة لخلق مستقبل جديد لذكاء البيانات',
  },
  dataBusiness: {
    title: 'أعمال ذكاء البيانات',
    subTitle: 'تقديم خدمات ذكاء البيانات الشاملة لمساعدة المؤسسات على تحقيق التحول الرقمي والذكي',
    menuList: ['معالجة البيانات متعددة الوسائط', 'بناء الوكلاء الأذكياء', 'دعم قوة الحوسبة عبر الحدود العالمية'],
  },
};
